import {theme} from 'ant-design-vue';

const antTheme = theme;

export default antTheme;
